module.exports = {
	DEFAULT_INITIAL_SIZE: (8 * 1024),
	DEFAULT_INCREMENT_AMOUNT: (8 * 1024),
	DEFAULT_FREQUENCY: 1,
	DEFAULT_CHUNK_SIZE: 1024
};
